import http from '../_http'

const service = {
  //default
  summaryService: (m) => {  return http.get(`manager/setting/service`, m); },
  listService: (m) => { return http.post(`manager/setting/service/list`, m); },
  detailService:(m) => { return http.get(`manager/setting/service/${m.id}`); },

  //crud
  insertService: (m) => { return http.post(`manager/setting/service`, m); },
  updateService: (m) => { return http.put(`manager/setting/service`, m); },
  deleteService: (m) => { return http.delete(`manager/setting/service/${m.id}`); },
}

export default service

export { service }